import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-8" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "d-flex flex-column col-4" }
const _hoisted_6 = { class: "small" }
const _hoisted_7 = { class: "d-flex justify-content-end mt-3" }

import { ref } from 'vue'
import { VueDatePicker } from '@vuepic/vue-datepicker';
import FileDownloadBtn from "@/components/Files/DownloadButton.vue"
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import i18n from "@/lang/i18n";

const downloadType = "App\\Services\\Csv\\Exports\\DataLinkageService"


export default /*@__PURE__*/_defineComponent({
  __name: 'DataLinkage',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

document.title = i18n.global.t('pages.dataLinkage.title')
const selectDate = ref(new Date())

const addRequestParams = (params:any) => {
  params['select_date'] = selectDate.value.toLocaleDateString()
  return params
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dataLinkage.title')), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.dataLinkage.date')), 1),
          _createVNode(_unref(VueDatePicker), {
            locale: _unref(ja),
            modelValue: selectDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectDate).value = $event)),
            formats: { input: 'yyyy/MM/dd' },
            "auto-apply": "",
            "close-on-auto-apply": true,
            clearable: false
          }, null, 8, ["locale", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(FileDownloadBtn, {
            showable: true,
            btnClass: "exec-btn mt-0 ml-1",
            btnName: _unref(i18n).global.t('common.downloadBtn'),
            type: downloadType,
            addRequestParams: addRequestParams
          }, null, 8, ["btnName"])
        ])
      ])
    ])
  ]))
}
}

})